import { render, staticRenderFns } from "./FeedbackMenu.vue?vue&type=template&id=c7ab8f6a&scoped=true"
import script from "./FeedbackMenu.vue?vue&type=script&lang=js"
export * from "./FeedbackMenu.vue?vue&type=script&lang=js"
import style0 from "./FeedbackMenu.vue?vue&type=style&index=0&id=c7ab8f6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7ab8f6a",
  null
  
)

export default component.exports